/** Dependencies */
import PermissionDetails from './PermissionDetails';
import PermissionDetailsWizard from './PermissionDetailsWizard';

export { PermissionDetailsWizard };

export default PermissionDetails;
